// eslint-disable-next-line check-moment-usage/no-moment-import -- existing usage, to be migrated
import moment from 'moment-timezone';

import { expVal } from '@confluence/feature-experiments';

export const guessTimeZone = (): string => {
	if (expVal('confluence_migrate_moment_to_native', 'isEnabled', false)) {
		try {
			return Intl.DateTimeFormat().resolvedOptions().timeZone;
		} catch {
			return 'Etc/UTC';
		}
	}

	return moment.tz.guess();
};
